module.exports = __webpack_public_path__ + "static/media/points6_5.e4fca6b7.png";